import React, { useMemo, useState } from 'react';
import Keyword from '@/pages/opinion/components/Keyword';
import SvgIcon from '@/pages/home/components/SvgIcon';
import '@/pages/opinion/assets/scss/pages/performance/components/otherTable.scss';
import {
  getRationPercentValue,
  mathFormat,
  sentimentType,
} from '@/pages/opinion/utils';
import { useIntl } from 'umi';
import { useGameOperations } from '@/pages/opinion/utils/game';
import { hasExcludeChannelsGameId } from '@/pages/opinion/constants';
import BubbleCommon, {
  gameListMentionsTips,
} from '@/pages/opinion/components/BubbleCommon';
import RenderGameIcon from '@/pages/opinion/components/RenderImg/renderGameIcon';
import { sentimentFormat } from '@/pages/opinion/utils/value';

export default function OtherTable({ gameInfo: { entity_type }, data, showAigcCard }: any) {
  const { formatMessage } = useIntl();

  const [localHasExcludeChannelsGameId, setLocalHasExcludeChannelsGameId] =
    useState(false);

  const headers = [
    {
      id: 'dau',
      title:
        entity_type === 'mobile'
          ? formatMessage({ id: 'Game (Sort by DAU)' })
          : formatMessage({ id: 'Game' }),
    },
    {
      id: 'new_mention',
      title: (
        <>
          <span>{formatMessage({ id: 'Mentions' })}</span>
          {localHasExcludeChannelsGameId && (
            <BubbleCommon
              placement="top"
              tipsMap={gameListMentionsTips}
              iconStyle={{ position: 'relative', top: 3, marginLeft: 5 }}
            ></BubbleCommon>
          )}
        </>
      ),
    },
    { id: 'new_avg_sentiment', title: formatMessage({ id: 'Sentiment' }) },
  ];

  // 下拉箭头选项
  const [sortName, setSortName] = useState(
    entity_type === 'mobile' ? 'dau' : 'new_mention',
  );

  const renderData = useMemo(() => {
    let result = data?.map((item: any) => ({
      ...item,
      sentiment_dod: getRationPercentValue(
        item.new_avg_sentiment,
        item.old_avg_sentiment,
        2,
      ),
      mentions_dod: getRationPercentValue(
        item.new_mention,
        item.old_mention,
        2,
      ),
    }));
    result?.sort((a: any, b: any) => {
      let value1 = a[sortName];
      let value2 = b[sortName];
      const orders: any = {
        dau: ['new_mention', 'new_avg_sentiment'],
        new_mention: ['dau', 'new_avg_sentiment'],
        new_avg_sentiment: ['dau', 'new_mention'],
      };

      const order = orders[sortName];
      if (value1 === value2) {
        let value3 = a[order[0]];
        let value4 = b[order[0]];
        if (value3 === value4) {
          let value5 = a[order[1]];
          let value6 = b[order[1]];
          return value6 - value5;
        } else {
          return value4 - value3;
        }
      } else {
        return value2 - value1;
      }
    });

    setLocalHasExcludeChannelsGameId(
      hasExcludeChannelsGameId(
        result.map(
          (item: { edition_unified_id: string }) => item.edition_unified_id,
        ),
      ),
    );

    return result;
  }, [data, sortName]);
  return (
    <div className="dbo-performance-competitorbox">
      <div className="competitor-header">
        {headers.map((item) => {
          return (
            <div
              onClick={() => {
                if (!(entity_type !== 'mobile' && item.id === 'dau')) {
                  setSortName(item.id);
                }
              }}
              key={item.id}
              className={`competitor-header-item ${sortName == item.id ? 'competitor-header-item--sorted' : ''
                } ${entity_type !== 'mobile' && item.id === 'dau'
                  ? 'competitor-header-item--stable'
                  : ''
                }`}
            >
              {item.title}

              {!(entity_type !== 'mobile' && item.id === 'dau') ? (
                <i>
                  <SvgIcon
                    className="competitor-header-icon"
                    type={sortName == item.id ? 'down-arrow-icon' : 'sort-icon'}
                  />
                </i>
              ) : null}
            </div>
          );
        })}
      </div>
      <div className={`competitor-table ${showAigcCard?'competitor-table-height':''}`}>
        {renderData?.map?.((item: any) => (
          <DataShow item={item} key={item.edition_unified_id} />
        ))}
        {renderData?.length <= 2 && <NoData />}
      </div>
    </div>
  );
}

const DataShow = ({ item }: { item: any }) => {
  const { handleChangeGame } = useGameOperations();

  return (
    <div
      className="competitor-item"
      onClick={() => {
        handleChangeGame(item, true);
      }}
    >
      <div className="competitor-content">
        <div className="competitor-title">
          {/* <img className="competitor-img" src={item.cover} alt="" /> */}
          <RenderGameIcon
            className="competitor-img"
            gameInfo={item}
          ></RenderGameIcon>
          <div className="text-title">{item.entity_name}</div>
        </div>
        <div className="competitor-mentions">
          <div className="competitor-mentions-top">
            {mathFormat(item.new_mention)}
          </div>
          <div className="competitor-gray">
            {item.mentions_dod >= 0
              ? item.mentions_dod
              : item.mentions_dod?.toString()?.substring(1)}
            %&nbsp;
            {item.mentions_dod !== 0 && (
              <SvgIcon
                type={
                  item.mentions_dod > 0
                    ? 'rising-arrow-icon'
                    : 'down-arrow-icon'
                }
                className="competitor-gray-icon"
              />
            )}
          </div>
        </div>
        <div className="competitor-mentions">
          <div className="competitor-mentions-top">
            {sentimentFormat(item.new_avg_sentiment)}
          </div>
          <div className="competitor-gray">
            {item.sentiment_dod >= 0
              ? item.sentiment_dod
              : item.sentiment_dod?.toString()?.substring(1)}
            %&nbsp;
            {item.sentiment_dod !== 0 && (
              <SvgIcon
                type={
                  item.sentiment_dod > 0
                    ? 'rising-arrow-icon'
                    : 'down-arrow-icon'
                }
                className="competitor-gray-icon"
              />
            )}
          </div>
        </div>
      </div>

      {item?.keywords?.length > 0 && (
        <div className="competitor-tab">
          {item?.keywords?.map?.((item: any) => {
            return (
              <Keyword
                stabled
                key={item.keyword}
                data={{
                  text: item.keyword,
                  type: sentimentType(item.sentiment_rating, true),
                }}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

const NoData = () => {
  const { formatMessage } = useIntl();
  return (
    <div className="competitor-more">
      {formatMessage({ id: 'More competitors will be added in the future.' })}
    </div>
  );
};
